import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _24d98cf3 = () => interopDefault(import('../pages/certification.vue' /* webpackChunkName: "pages/certification" */))
const _3a4b8644 = () => interopDefault(import('../pages/code.vue' /* webpackChunkName: "pages/code" */))
const _f1d1a0a0 = () => interopDefault(import('../pages/events.vue' /* webpackChunkName: "pages/events" */))
const _36bada8f = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _8e80926e = () => interopDefault(import('../pages/how.vue' /* webpackChunkName: "pages/how" */))
const _6e3a8d20 = () => interopDefault(import('../pages/Instructions.pdf.vue' /* webpackChunkName: "pages/Instructions.pdf" */))
const _230f2dbc = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _d390b05c = () => interopDefault(import('../pages/mypage.vue' /* webpackChunkName: "pages/mypage" */))
const _7c341181 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _64d997f0 = () => interopDefault(import('../pages/reset.vue' /* webpackChunkName: "pages/reset" */))
const _2ceea82f = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _97801b70 = () => interopDefault(import('../pages/support.vue' /* webpackChunkName: "pages/support" */))
const _6262f780 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _3ce2a898 = () => interopDefault(import('../pages/upload.vue' /* webpackChunkName: "pages/upload" */))
const _1d4b0821 = () => interopDefault(import('../pages/app/faq.vue' /* webpackChunkName: "pages/app/faq" */))
const _c160374a = () => interopDefault(import('../pages/app/how.vue' /* webpackChunkName: "pages/app/how" */))
const _1cef2613 = () => interopDefault(import('../pages/app/privacy.vue' /* webpackChunkName: "pages/app/privacy" */))
const _54fb06da = () => interopDefault(import('../pages/app/support.vue' /* webpackChunkName: "pages/app/support" */))
const _52099552 = () => interopDefault(import('../pages/app/terms.vue' /* webpackChunkName: "pages/app/terms" */))
const _24d0c60b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/certification",
    component: _24d98cf3,
    name: "certification"
  }, {
    path: "/code",
    component: _3a4b8644,
    name: "code"
  }, {
    path: "/events",
    component: _f1d1a0a0,
    name: "events"
  }, {
    path: "/faq",
    component: _36bada8f,
    name: "faq"
  }, {
    path: "/how",
    component: _8e80926e,
    name: "how"
  }, {
    path: "/Instructions.pdf",
    component: _6e3a8d20,
    name: "Instructions.pdf"
  }, {
    path: "/login",
    component: _230f2dbc,
    name: "login"
  }, {
    path: "/mypage",
    component: _d390b05c,
    name: "mypage"
  }, {
    path: "/privacy",
    component: _7c341181,
    name: "privacy"
  }, {
    path: "/reset",
    component: _64d997f0,
    name: "reset"
  }, {
    path: "/signup",
    component: _2ceea82f,
    name: "signup"
  }, {
    path: "/support",
    component: _97801b70,
    name: "support"
  }, {
    path: "/terms",
    component: _6262f780,
    name: "terms"
  }, {
    path: "/upload",
    component: _3ce2a898,
    name: "upload"
  }, {
    path: "/app/faq",
    component: _1d4b0821,
    name: "app-faq"
  }, {
    path: "/app/how",
    component: _c160374a,
    name: "app-how"
  }, {
    path: "/app/privacy",
    component: _1cef2613,
    name: "app-privacy"
  }, {
    path: "/app/support",
    component: _54fb06da,
    name: "app-support"
  }, {
    path: "/app/terms",
    component: _52099552,
    name: "app-terms"
  }, {
    path: "/",
    component: _24d0c60b,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
